import { Currency } from "library/types";

export const TransitionConst = "150ms";

export const PageSize = 30;

export const CurrencyDescription: { [key in Currency]: string } = {
  usd: "USD",
};
